
export default [
  {
    name: 'AuthenticationIndex',
    path: '/authentication/index',
    hidden: true,
    component: (resolve) => require(['@/views/authentication/index'], resolve),
    meta: { title: 'Producer Authentication', noCache: false, affix: false },
    roles: [0, 9]
  },
  // {
  //   name:"AuthenticationBusinessKYC",
  //   path: '/authentication/businessKYC',
  //   component: (resolve) => require(['@/views/authentication/businessKYC'], resolve),
  //   hidden:true,
  //   meta: { title: 'Producer Authentication', noCache: false, affix: false },
  //   roles:[0]
  // },
  // {
  //   name:"AuthenticationPersonalKYC",
  //   path: '/authentication/personalKYC',
  //   component: (resolve) => require(['@/views/authentication/personalKYC'], resolve),
  //   hidden:true,
  //   meta: { title: 'Producer Authentication', noCache: false, affix: false },
  //   roles:[0]
  // },
  {
    name: 'AuthenticationApprove',
    path: '/authentication/approve',
    component: (resolve) => require(['@/views/authentication/approve/index'], resolve),
    meta: { title: 'Producer Management', noCache: false, affix: false, checkAccount: true },
    roles: [1]
  },
  {
    name: 'AuthenticationApproveDetail',
    path: '/authentication/approve/detail',
    hidden: true,
    component: (resolve) => require(['@/views/authentication/approve/detail'], resolve),
    meta: { title: 'Producer Authentication', noCache: false, affix: false, checkAccount: true },
    roles: [1]
  }
]
